import { render, staticRenderFns } from "./DetailsPage_privileges.vue?vue&type=template&id=284c93ae&scoped=true&"
import script from "./DetailsPage_privileges.vue?vue&type=script&lang=js&"
export * from "./DetailsPage_privileges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c93ae",
  null
  
)

export default component.exports